module.exports = __webpack_public_path__ + "static/img/img-tuto02-02.014fc3cd.gif";